import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import ActionButton from "../../controls/ActionButton";
import { formatCurrency } from "../../../shared/utility";

export default function PurchaseOrderLineItemRow({
  row,
  assemblyItemOptions,
  onAssemblySelect,
  updateLineItem,
  onRemove,
}) {
  const assemblyValue =
    assemblyItemOptions.find((o) => o.value === row.assembly_item_id) || null;
  const uomLabel = row.unit_of_measure?.label ?? "—";
  const lineTotal = row.lineTotal;

  return (
    <tr className="border-b border-[#E2E8F0]/70 align-top">
      <td className="min-w-[200px] px-3 py-3">
        <SelectMenu
          name={`item-${row.temp_id}`}
          options={assemblyItemOptions}
          value={assemblyValue}
          handleInputChange={(e) =>
            onAssemblySelect(row.temp_id, e.target.value)
          }
          placeholder="Select item…"
          menuPortalTarget={document.body}
        />
      </td>
      <td className="w-24 px-3 py-3">
        <Input
          name={`qty-${row.temp_id}`}
          type="number"
          min="0"
          step="any"
          value={row.ordered_quantity}
          onChange={(e) =>
            updateLineItem(row.temp_id, { ordered_quantity: e.target.value })
          }
        />
      </td>
      <td className="w-28 px-3 py-3 text-center align-middle text-sm font-medium text-[#64748B]">
        {uomLabel}
      </td>
      <td className="w-28 px-3 py-3">
        <Input
          name={`cost-${row.temp_id}`}
          type="number"
          min="0"
          step="any"
          value={row.unit_cost}
          onChange={(e) =>
            updateLineItem(row.temp_id, { unit_cost: e.target.value })
          }
        />
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-sm font-medium tabular-nums text-[#0F172A]">
        {lineTotal != null ? formatCurrency(lineTotal) : "—"}
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right">
        <ActionButton
          color="red"
          className="min-w-0 px-3"
          disabled={row.line_locked}
          onClick={() => onRemove(row.temp_id)}
        >
          Delete
        </ActionButton>
      </td>
    </tr>
  );
}
